import "./Home.css";
import logo from "../assets/logo.png";

function Home() {
    return (
        <section className="home-container" id="home">
            <div className="hero-content">
                <img
                    src={logo}
                    alt="Thai Nursery Logo"
                    className="hero-logo"
                />

                <h1 className="hero-title">Thai Nursery</h1>

                <p className="hero-subtitle">
                    Bringing Nature Closer to You 🌿
                </p>
            </div>
        </section>
    );
}

export default Home;